<template>
  <div>
    <pea-summary ref="peaSummary" :peaId="mainPeaId" :disabled="disableEditing" v-on:updateYears="updateYears"></pea-summary>
    <br />
    <div>
      After creation of Summary information all PEA sections will become available.
    </div>
    <br />

    <el-alert v-if="alertTitle !== ''"
      :title="alertTitle"
      :type="alertType"
      :description="callInfo"
      :closable="false"
      show-icon>
    </el-alert>
    <el-button type="primary" class="btn btn-primary" :loading="this.isLoading" @click="create()">Create</el-button>
    <br />
    <div v-if="isLoading">
      Submit Processing...
    </div>
  </div>
</template>

<script>
import router from '../router'
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'createPEA',
  data () {
    return {
      isLoading: false,
      callInfo: '',
      alertType: '',
      alertTitle: '',
      peaSummaryValidState: false,
      mainPeaId: 0,
      disableEditing: true
    }
  },
  created: function () {
    this.$on('peaSummaryValidation', function (value) {
      this.peaSummaryValidState = value
    })
    this.startUp()
  },
  methods: {
    startUp () {
      // creating new PEA so can editPEA
      this.disableEditing = false
      this.startingYear = new Date().getFullYear()
    },
    create () {
      // catch multi clicks
      if (this.isLoading === true) {
        return
      }
      this.isLoading = true
      this.alertTitle = ''
      // check forms
      var formValid = false
      this.checkFormValidation()
      if (this.peaSummaryValidState === true) {
        formValid = true
      }
      if (formValid) {
        const loading = this.$loading({
          lock: true,
          text: 'Processing',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        setTimeout(() => {
          loading.close()
        }, 15000)
        this.$refs.peaSummary.summaryFormSubmit().then(response => {
          this.mainPeaId = response.data.id
          this.isLoading = false
          loading.close()
          helperMethods.showNotification(this, 'PEA Successfully Created!', 'PEA Created', 'success', 10000)
          router.push('/editPEA/' + this.mainPeaId)
        }).catch(reject => {
          this.isLoading = false
          loading.close()
          // error handled in peaSummary
        })
      } else {
        this.isLoading = false
      }
    },
    checkFormValidation () {
      this.$refs.peaSummary.checkSummaryValid()
    },
    updateYears () {
      this.startingYear = this.$refs.peaSummary.peaCore.projectStartDate.getFullYear()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
